export const TabGroup = `
  <TabGroup
    tabNumber=1 // number
    error=["error"] // Record<string, any>
    children={} // React.ReactNode
    showTabNumberIcon={true} // boolean
    selectColorText={'text-black-400'} String
    selectedColorBackground={'bg-black'} // String
    selectedColorBorder={'border-black'} // String
    tabConfiguration={[{name: "tab name"}]}
    pannelConfiguraton={[{name: "tab name", component: <Component/>}]}
  />
`
